import * as React from "react";
const SvgDuplicate20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 19,
        height: 18,
        viewBox: "0 0 19 18",
        fill: "black"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M18.5 0h-13v13h13V0Zm-11 11V2h9v9h-9Zm-3-6h-4v13h13v-4h-2v2h-9V7h2V5Z",
      clipRule: "evenodd"
    })
  );
export default SvgDuplicate20Px;
